import React from 'react';
import { FloatLabel } from '../../../Components';

interface AddressLegalRepresentativePartialFormProps<T> {
    values: T;
    onChange: <K extends keyof T>(field: K, value: T[K]) => void;
    onChangeNumberAddress?: (value: string) => void;
    errors?: Partial<Record<keyof T, string>>;
    dictNameLegalRepresentativeLabel: string;
    dictSurnameLegalRepresentativeLabel: string;
    dictAddressStreetLabel: string;
    dictAddressNumberLabel: string;
    dictAddressPostalLabel: string;
    dictAddressLocalityLabel: string;
    dictErrorSubmit: string;
    dictTitleLegalRepresentativeContactDetails: string;
}

const AddressLegalRepresentativePartialForm = <
    T extends {
        nameLegalRepresentative: string;
        surnameLegalRepresentative: string;
        addressStreetLegalRepresentative: string;
        addressNumberLegalRepresentative: string;
        addressPostalLegalRepresentative: string;
        addressLocalityLegalRepresentative: string;
    },
>({
    values,
    onChange,
    onChangeNumberAddress,
    errors,
    dictAddressStreetLabel,
    dictNameLegalRepresentativeLabel,
    dictSurnameLegalRepresentativeLabel,
    dictAddressNumberLabel,
    dictAddressPostalLabel,
    dictErrorSubmit,
    dictTitleLegalRepresentativeContactDetails,
    dictAddressLocalityLabel,
}: AddressLegalRepresentativePartialFormProps<T>) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h2 className="h2">
                        {dictTitleLegalRepresentativeContactDetails}{' '}
                    </h2>
                </div>
            </div>
            <div className="row">
                <div className="col-10">
                    <FloatLabel
                        active={!!values.nameLegalRepresentative}
                        label={dictNameLegalRepresentativeLabel}
                        labelId="nameLegalRepresentative"
                    >
                        <input
                            type="text"
                            name="nameLegalRepresentative"
                            value={values.nameLegalRepresentative}
                            onChange={(e) =>
                                onChange(
                                    'nameLegalRepresentative',
                                    e.target.value
                                )
                            }
                        />
                    </FloatLabel>
                    {errors?.nameLegalRepresentative && (
                        <div className="row">
                            <label className="alert-danger m-auto">
                                {dictErrorSubmit}
                            </label>
                        </div>
                    )}
                </div>
                <div className="col-10">
                    <FloatLabel
                        active={!!values.surnameLegalRepresentative}
                        label={dictSurnameLegalRepresentativeLabel}
                        labelId="surnameLegalRepresentative"
                    >
                        <input
                            type="text"
                            name="surnameLegalRepresentative"
                            value={values.surnameLegalRepresentative}
                            onChange={(e) =>
                                onChange(
                                    'surnameLegalRepresentative',
                                    e.target.value
                                )
                            }
                        />
                    </FloatLabel>
                    {errors?.surnameLegalRepresentative && (
                        <div className="row">
                            <label className="alert-danger m-auto">
                                {dictErrorSubmit}
                            </label>
                        </div>
                    )}
                </div>
                <div className="col-10">
                    <FloatLabel
                        active={!!values.addressStreetLegalRepresentative}
                        label={dictAddressStreetLabel}
                        labelId="addressStreetLegalRepresentative"
                    >
                        <input
                            type="text"
                            name="addressStreetLegalRepresentative"
                            value={values.addressStreetLegalRepresentative}
                            onChange={(e) =>
                                onChange(
                                    'addressStreetLegalRepresentative',
                                    e.target.value
                                )
                            }
                        />
                    </FloatLabel>
                    {errors?.addressStreetLegalRepresentative && (
                        <div className="row">
                            <label className="alert-danger m-auto">
                                {dictErrorSubmit}
                            </label>
                        </div>
                    )}
                </div>

                <div className="col-2">
                    <FloatLabel
                        active={!!values.addressNumberLegalRepresentative}
                        label={dictAddressNumberLabel}
                        labelId="addressNumberLegalRepresentative"
                    >
                        <input
                            type="text"
                            name="addressNumberLegalRepresentative"
                            value={values.addressNumberLegalRepresentative}
                            onChange={(e) =>
                                onChangeNumberAddress
                                    ? onChangeNumberAddress(e.target.value)
                                    : onChange(
                                          'addressNumberLegalRepresentative',
                                          e.target.value
                                      )
                            }
                        />
                    </FloatLabel>
                    {errors?.addressNumberLegalRepresentative && (
                        <div className="row">
                            <label className="alert-danger m-auto">
                                {dictErrorSubmit}
                            </label>
                        </div>
                    )}
                </div>

                <div className="col-4">
                    <FloatLabel
                        active={!!values.addressPostalLegalRepresentative}
                        label={dictAddressPostalLabel}
                        labelId="addressPostalLegalRepresentative"
                    >
                        <input
                            type="text"
                            name="addressPostalLegalRepresentative"
                            value={values.addressPostalLegalRepresentative}
                            onChange={(e) =>
                                onChange(
                                    'addressPostalLegalRepresentative',
                                    e.target.value
                                )
                            }
                        />
                    </FloatLabel>
                    {errors?.addressPostalLegalRepresentative && (
                        <div className="row">
                            <label className="alert-danger m-auto">
                                {dictErrorSubmit}
                            </label>
                        </div>
                    )}
                </div>

                <div className="col-8">
                    <FloatLabel
                        active={!!values.addressLocalityLegalRepresentative}
                        label={dictAddressLocalityLabel}
                        labelId="addressLocality"
                    >
                        <input
                            type="text"
                            name="addressLocalityLegalRepresentative"
                            value={values.addressLocalityLegalRepresentative}
                            onChange={(e) =>
                                onChange(
                                    'addressLocalityLegalRepresentative',
                                    e.target.value
                                )
                            }
                        />
                    </FloatLabel>
                    {errors?.addressLocalityLegalRepresentative && (
                        <div className="row">
                            <label className="alert-danger m-auto">
                                {dictErrorSubmit}
                            </label>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default AddressLegalRepresentativePartialForm;
